// extracted by mini-css-extract-plugin
module.exports = {"autoComplete":"OR","error":"PR","disabled":"QR"};